import { ContentSettings, PageSettings } from "@tree-company/tree-query";
import t from "../locales";
import { PageComponent } from "../components/page";
import { translationFromKey } from "./helpers";
import { LanguageContext } from "../app";
import { useContext } from "react";

function Intro() {
  const language = useContext(LanguageContext);
  return (
    <div className="page__intro">
      <h1 className="page__title">{t("intro.title", {}, language)}</h1>
      <p className="page__intro-text">{t("intro.content", {}, language)}</p>
    </div>
  );
}

const content: ContentSettings = {
  type: "content",
  key: "intro",
  order: 0,
  component: Intro,
};

export const page_intro: PageSettings = {
  key: "intro",
  title: translationFromKey("intro.title"),
  order: 1,
  sections: [content],
  htmlAttributes: { class: "page--with-logo page--intro" },
  component: PageComponent,
};
